export default __webpack_public_path__ + "static/media/Mundo_hecho_de_Banderas.85a913c2.gif";